'use strict';

angular.module('bringgApp').directive('defaultCashOutTemplate', function ($translate, $timeout) {
	return {
		restrict: 'E',
		scope: {
			data: '=',
			employee: '=',
			config: '=',
			totals: '=',
			footers: '=',
			date: '=',
			printCallback: '='
		},
		link: function (scope, element) {
			$timeout(scope.printCallback, 100, true, element);
		},
		templateUrl: 'scripts/features/print/cash_out/default-cash-out-template.html'
	};
});
